import { EVENT_IRRIGATION_UNITS, IrrigationEvent } from '@cibo/core'
import { DateRangePickerField, NumberInputField, SelectField } from '@cibo/ui'
import ClearIcon from '@mui/icons-material/Clear'
import { IconButton, Stack, TableCell, TableRow } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { EventComponentProps } from '../EventDetail'

export const IrrigationEventEditor = ({
  year,
  name,
  eventIndex,
  onPressRemove,
  parentName,
  isImmutable,
}: EventComponentProps) => {
  const { t } = useTranslation('@cibo/landmanager/EventIrrigationEditor')

  const startMonth = new Date(year, 4)
  const { getFieldMeta } = useFormikContext()
  const parentField = getFieldMeta<{ events: IrrigationEvent[] }>(parentName)

  return (
    <TableRow key={name}>
      <TableCell sx={{ verticalAlign: 'top' }}>
        <DateRangePickerField
          startRangeFieldName={`${name}.startDate`}
          endRangeFieldName={`${name}.endDate`}
          shouldDisableDate={(day: Date | Dayjs, position) =>
            parentField.value.events
              .filter((f, i) => i !== eventIndex)
              .some(
                event =>
                  event.startDate &&
                  event.endDate &&
                  dayjs(day).isSameOrAfter(dayjs(event.startDate)) &&
                  (dayjs(day).isSame(dayjs(event.endDate)) ||
                    dayjs(day).isBefore(dayjs(event.endDate)))
              )
          }
          data-testid={`${name}.dateRange`}
          name={name}
          disabled={isImmutable}
          minDate={new Date(year - 1, 6, 1)}
          maxDate={new Date(year + 1, 0, 1)}
          referenceDate={startMonth}
        />
      </TableCell>

      <TableCell sx={{ verticalAlign: 'top' }}>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            '& .MuiFormControl-root': {
              flex: 1,
            },
          }}
        >
          <NumberInputField
            name={`${name}.amount`}
            style={{ flex: 1, width: '60px' }}
            disabled={isImmutable}
            min={0}
            data-testid={`${name}.amount`}
          />

          <SelectField
            fieldName={`${name}.unit`}
            style={{ flex: 1, width: '90px' }}
            options={EVENT_IRRIGATION_UNITS}
            disabled={isImmutable}
            renderOption={value => t('irrigationType', { context: value })}
          />
        </Stack>
      </TableCell>

      <TableCell>
        <IconButton
          aria-label={t('removeEvent') as string}
          onClick={onPressRemove}
          disabled={isImmutable}
        >
          <ClearIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}
